import React, { useEffect, useState } from "react";
import { Container, Button } from "reactstrap";
import TuneIcon from "@mui/icons-material/Tune";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ReplayIcon from "@mui/icons-material/Replay";
import { useNavigate } from "react-router-dom";
import { management_approval_list } from "../../../api/requisition";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import { fetchFilterListForAllocation } from "../../../api/approval";
import dayjs from "dayjs";

const ApprovalRequisition = () => {
  const dispatch = useDispatch();
  dispatch(StorePageHeaderName("Approval Requisition"));
  const [showList, setShowList] = useState(false);
  const [approvalRows, setApprovalRows] = useState([]);
  const [gridLoad, setGridLoad] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);

  const navigate = useNavigate();

  const toggleList = () => {
    setShowList(!showList);
  };
  const goToRequisition = (params) => {
    navigate("/management/approval-requisition-details", { state: params.row });
  };

  document.title = "Approval Requisition";

  const columns = [
    {
      field: "sl_no",
      headerName: "Sl. No.",
      sortable: false,
      resizable: false,
      flex: 0.6,
    },
    // {
    //   field: "requisition_date",
    //   headerName: "Requisition Date",
    //   sortable: false,
    //   resizable: false,
    //   flex: 1,
    // },
    {
      field: "vendor_name",
      headerName: "Vendor Name",
      sortable: false,
      resizable: false,
      flex: 1,
    },
    {
      field: "requisiton_number",
      headerName: "Requisition Number",
      sortable: false,
      resizable: false,
      flex: 1,
    },
    {
      field: "total_value",
      headerName: "Total Value",
      headerClassName: "table-header-background",
      editable: false,
      sortable: false,
      resizable: false,
      flex: 1,
    },
    {
      field: "Status",
      headerName: "Action",
      headerClassName: "table-header-background",
      sortable: false,
      resizable: false,
      width: 160,
      renderCell: (params) => {
        return (
          <div className="mt-2">
            <button
              className="modified_button p-1 ps-2 pe-2 d-flex align-items-center"
              onClick={() => goToRequisition(params)}
            >
              View Details
            </button>
          </div>
        );
      },
    },
  ];

  const getManagamentApprovalList = async (
    product = null,
    vendor = null,
    start_date = null,
    end_date = null
  ) => {
    try {
      setGridLoad(true);
      const payload = {
        product,
        vendor,
        start_date,
        end_date,
      };
      const response = await management_approval_list(payload);
      const data = response.data.managementApprovalRequisitions.map(
        (item, index) => ({
          id: `${item.v_code}&${item.requisition_date}`,
          sl_no: index + 1,
          requisition_date: item.requisition_date,
          vendor_name: item.v_name,
          total_fob_value: item.value,
        })
      );
      setApprovalRows(data);
    } catch (error) {
      toast.error(
        error.message || "An error occurred while fetching the approval list"
      );
    } finally {
      setGridLoad(false);
    }
  };

  const fetchFilterList = async () => {
    try {
      const list = await fetchFilterListForAllocation({
        filter_type: ["vendor", "product"],
      });
      if (list.statusCode === 200) {
        if (list.data.response.productList.length > 0) {
          setProductOptions(list.data.response.productList);
        }
        if (list.data.response.vendorList.length > 0) {
          setVendorOptions(list.data.response.vendorList);
        }
      }
    } catch (error) {
      toast.error("Error in fetching filter list");
      console.log(error);
    }
  };

  const handleReset = () => {
    setSelectedProduct(null);
    setSelectedVendor(null);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    getManagamentApprovalList();
  };

  const handleStartDateChange = (startDate) => {
    try {
      if (
        selectedEndDate &&
        startDate &&
        dayjs(startDate).isAfter(dayjs(selectedEndDate))
      ) {
        throw new Error("Start date cannot be after end date");
      }
      setSelectedStartDate(startDate);
    } catch (err) {
      setSelectedStartDate(null);
      toast.error(err.message);
    }
  };

  const handleEndDateChange = (endDate) => {
    try {
      if (
        selectedStartDate &&
        endDate &&
        dayjs(endDate).isBefore(dayjs(selectedStartDate))
      ) {
        throw new Error("End date cannot be before start date");
      }
      setSelectedEndDate(endDate);
    } catch (err) {
      setSelectedEndDate(null);
      toast.error(err.message);
    }
  };

  const handleSearch = () => {
    try {
      const product = selectedProduct ? selectedProduct.value : null;
      const vendor = selectedVendor ? selectedVendor.value : null;
      const start_date = selectedStartDate
        ? dayjs(selectedStartDate).format("YYYY-MM-DD")
        : null;
      const end_date = selectedEndDate
        ? dayjs(selectedEndDate).format("YYYY-MM-DD")
        : null;
      if(product || vendor || (start_date && end_date)){
        getManagamentApprovalList(product, vendor, start_date, end_date);
      } else {
        throw new Error('Please select proper search parameter.')
      }
    } catch (err) {
      toast.error(err.message)
    }
  };

  useEffect(() => {
    if (showList) {
      fetchFilterList();
    }
  }, [showList]);

  useEffect(() => {
    getManagamentApprovalList();
  }, []);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div>
            <div>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h4 className="requisition_text mb-0">Approval Requisition</h4>
                </div>
                <div>
                  <button onClick={toggleList} className="filter_button">
                    <span className="me-2">
                      <TuneIcon />
                    </span>
                    Filter
                  </button>
                </div>
              </div>
              {showList && (
                <div
                  className="mt-2"
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div>
                    <Autocomplete
                      className="data_field"
                      disablePortal
                      id="product"
                      options={productOptions}
                      sx={{ width: 220 }}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Product" />
                      )}
                      onInputChange={(event, newValue) => {
                        const getVal = productOptions.find(
                          (el) => el.label === newValue
                        );
                        setSelectedProduct(getVal || null);
                      }}
                      onChange={(event, newValue) => {
                        setSelectedProduct(newValue || null);
                      }}
                      getOptionLabel={(option) => option?.label || ""}
                      isOptionEqualToValue={(option, value) =>
                        option?.value === value?.value
                      }
                      value={selectedProduct}
                    />
                  </div>
                  <div>
                    <Autocomplete
                      className="data_field"
                      disablePortal
                      id="vendor"
                      options={vendorOptions}
                      sx={{
                        width: 190,
                      }}
                      onInputChange={(event, newValue) => {
                        const getVal = vendorOptions.find(
                          (el) => el.label === newValue
                        );
                        setSelectedVendor(getVal || null);
                      }}
                      onChange={(event, newValue) => {
                        setSelectedVendor(newValue || null);
                      }}
                      getOptionLabel={(option) => option?.label || ""}
                      isOptionEqualToValue={(option, value) =>
                        option?.value === value?.value
                      }
                      value={selectedVendor}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Vendor" />
                      )}
                    />
                  </div>
                  <div className="d-flex">
                    {/* <button className="date_button" variant="contained" onClick={datepickeropenModal}>Select Date</button> */}
                    <div>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          className="date_picker"
                          label="From Date"
                          value={selectedStartDate}
                          onChange={handleStartDateChange}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider>
                    </div>
                    <div className="ms-2">
                      <LocalizationProvider
                        className="date_picker"
                        dateAdapter={AdapterDayjs}
                      >
                        <DatePicker
                          className="date_picker"
                          label="To Date"
                          value={selectedEndDate}
                          onChange={handleEndDateChange}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  {/* <div>
                    <Autocomplete
                      className="data_field"
                      disablePortal
                      id="combo-box-demo"
                      options={statusOptions}
                      sx={{ width: 170 }}
                      renderInput={(params) => (
                        <TextField {...params} label="Status" />
                      )}
                      value={selectedStatus}
                      onChange={handleEndDateChange}
                    />
                  </div> */}
                  <div>
                    <Button
                      className="me-2"
                      variant="outlined"
                      onClick={handleSearch}
                    >
                      Search
                    </Button>
                    <ReplayIcon onClick={handleReset} />
                  </div>
                </div>
              )}
            </div>

            <Box
              sx={{
                height: "100%",
                width: "100%",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              <DataGrid
                autoHeight
                className="table_header_background"
                headerClassName="custom-header-cell"
                rows={approvalRows}
                columns={columns}
                loading={gridLoad}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                disableRowSelectionOnClick
                disableColumnMenu
                disableColumnResize={true}
                componentsProps={{
                  cell: {
                    disableClick: true,
                  },
                }}
                sx={{
                  "& .MuiDataGrid-cell": {
                    "& .MuiDataGrid-cell--textOverflow": {
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                  },
                }}
              />
            </Box>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ApprovalRequisition;
